"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var dropdownSelectStyles = makeStyles_1.default(function (_a) {
    var _b;
    var palette = _a.palette, typography = _a.typography, spacing = _a.spacing, transitions = _a.transitions, breakpoints = _a.breakpoints;
    return ({
        fieldWrapper: {},
        root: {
            background: palette.common.white,
        },
        select: {
            width: '100%',
            height: 'fit-content',
            '&:focus': {
                background: palette.common.white,
            },
        },
        errorText: {
            margin: spacing(1),
            fontSize: typography.fontXS,
            color: palette.error.main,
        },
        outlined: {
            borderRadius: '3px',
            borderWidth: 1,
            '& $notchedOutline': {
                borderColor: palette.text.secondary,
            },
        },
        selectError: {
            borderColor: palette.error.main,
        },
        label: {
            fontFamily: typography.fontFamily2,
            color: palette.text.primary,
            marginBottom: 6,
            lineHeight: '20px',
        },
        disabled: {
            background: palette.background.alternate,
        },
        item: {
            transition: transitions.create(['background', 'color']),
            color: palette.text.primary,
            fontSize: typography.fontMD,
            backgroundColor: palette.common.white,
            '&:hover': {
                backgroundColor: palette.primary.main,
                '&:not([aria-selected])': (_b = {
                        color: palette.common.white
                    },
                    _b[breakpoints.down(breakpoints.values.sm)] = {
                        backgroundColor: palette.common.white,
                        color: palette.text.primary,
                    },
                    _b),
            },
        },
        itemDisabled: {
            borderColor: palette.text.secondary,
            color: palette.primaryDisabled.main,
            '&.Mui-disabled': {
                opacity: 1,
                backgroundColor: palette.common.white,
            },
        },
        hideSalutation: {},
    });
}, { name: 'GqlCheckout_DropdownSelect' });
exports.default = dropdownSelectStyles;
